import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../vue";
import { message } from 'ant-design-vue';
import { cloneDeep } from "lodash-es";
import { clearVariableSchema, getCustomVarSchema, upsertVariableSchema } from "../MethodEditor/variablesSchema/common";
import SchemaTreeView from "../SchemaTreeView/SchemaTreeView";
import { AnyInput } from '@tencent/ui-core';
import { fromJsonData } from '@tencent/data-schema-core/lib/convertor/jsonData';
import { cloneFast } from "../../tools/lang";
import { diffSchema } from "../../tools/schema/diffSchema";
import { getValueInWriteProxy, hasValueInWriteProxy } from "../../core/stateJS/utils/defineProxyState";
// 还原类型（清空） 更新类型  手动编辑类型(代码模式，可视化)
let DsVarModal = class DsVarModal extends Vue {
  constructor() {
    super(...arguments);
    this.schema = {};
    this.showSchema = false;
    this.hasDifferences = false;
    this.schemaDifferences = [];
  }
  reset() {
    const {
      designer,
      instance,
      variableName
    } = this.options;
    clearVariableSchema({
      designer,
      instance,
      variableName
    });
    this.close({
      action: 'reset',
      refresh: true
    });
  }
  updateByValue() {
    const {
      schemaProcess,
      designer,
      instance
    } = this.options;
    schemaProcess === null || schemaProcess === void 0 || schemaProcess.func({
      designer,
      instance
    });
    this.close({
      action: 'updateByValue'
    });
  }
  async update() {
    var _this$originSchema;
    const {
      designer,
      instance,
      variableName
    } = this.options;
    const refresh = ((_this$originSchema = this.originSchema) === null || _this$originSchema === void 0 ? void 0 : _this$originSchema['ds:useExample']) !== this.schema['ds:useExample'] || this.useExample;
    this.setUcTag();
    upsertVariableSchema({
      designer,
      instance,
      newSchema: this.schema,
      variableName
    });
    this.close({
      action: 'update',
      refresh
    });
  }
  cancel() {
    this.close({
      action: 'cancel'
    });
  }
  close(res) {
    this.$emit('msg', res);
  }
  updateSchemaByExample() {
    const newSchema = fromJsonData(this.schema.example);
    const schema = {
      ...this.schema,
      fields: undefined,
      items: undefined,
      ...newSchema,
      example: this.schema.example
    };
    Object.assign(this.schema, schema);
    message.success('更新成功');
    this.hasDifferences = false;
    this.schemaDifferences = [];
  }
  checkExampleSchema() {
    const newSchema = fromJsonData(this.schema.example);
    const res = diffSchema(this.schema, newSchema, {
      targetName: '示例值'
    });
    console.log(res);
    this.hasDifferences = res.hasDifferences;
    this.schemaDifferences = res.differences;
  }
  useValueAsExample() {
    const value = this.hasRealValue ? getValueInWriteProxy(this.options.instance, this.options.variableName) : this.options.instance[this.options.variableName];
    const cloneValue = cloneFast(value);
    this.$set(this.schema, 'example', cloneValue);
  }
  get originSchema() {
    var _this$options$instanc;
    return (_this$options$instanc = this.options.instance.stateSchema.fields) === null || _this$options$instanc === void 0 ? void 0 : _this$options$instanc.find(item => item.id === this.options.variableName);
  }
  get sourceId() {
    var _this$options$instanc2;
    return String((_this$options$instanc2 = this.options.instance.options.sourceConfig) === null || _this$options$instanc2 === void 0 ? void 0 : _this$options$instanc2.id);
  }
  get showResetEntity() {
    const {
      designer,
      variableName
    } = this.options;
    const hasCustomSchema = getCustomVarSchema(designer, this.sourceId, variableName);
    return hasCustomSchema || this.useExample;
  }
  get useExample() {
    return this.schema['ds:useExample'];
  }
  get hasRealValue() {
    return hasValueInWriteProxy(this.options.instance, this.options.variableName);
  }
  setUcTag() {
    if (this.useExample) {
      Vue.set(this.schema, 'uc:tag', 'Mock');
    } else {
      Vue.delete(this.schema, 'uc:tag');
    }
  }
  created() {
    if (this.originSchema) {
      this.schema = cloneDeep({
        ...this.originSchema
      });
    }
    if (this.useExample) {
      this.checkExampleSchema();
    }
    this.$watch(() => this.schema.example, () => {
      // todo 检查是否schema有变更
      this.checkExampleSchema();
    });
  }
  renderSchemaInfo() {
    const h = this.$createElement;
    return h("a-collapse", {
      "style": "margin-top:8px;"
    }, [h("a-collapse-panel", {
      "key": "1",
      "attrs": {
        "header": "查看变量结构"
      }
    }, [h(SchemaTreeView, {
      "style": "margin: 10px 0;",
      "attrs": {
        "schema": this.schema,
        "primaryKeyEditable": false,
        "editable": true,
        "defaultExpandAll": true,
        "rootIdEditable": false
      }
    })])]);
  }
  renderDiffTip() {
    const h = this.$createElement;
    if (!this.useExample || !this.hasDifferences) {
      return;
    }
    const popoverContent = h("div", [this.schemaDifferences.map(item => h("p", [item]))]);
    const message = h("a-space", [h("a-popover", {
      "attrs": {
        "content": popoverContent
      }
    }, [h("div", [h("span", ["\u793A\u4F8B\u503C\u4E0E\u771F\u5B9E\u6570\u636E\u7684\u7ED3\u6784\u6709\u5DEE\u5F02"]), h("span", {
      "style": "margin-left:4px;text-decoration: underline;ont-weight: bold;"
    }, [`${this.schemaDifferences.length}个差异`])])]), h("a-button", {
      "attrs": {
        "icon": 'redo',
        "type": "link"
      },
      "style": "padding:0;",
      "on": {
        "click": this.updateSchemaByExample
      }
    }, ["\u66F4\u65B0\u53D8\u91CF\u7ED3\u6784"])]);
    return h("a-alert", {
      "style": "margin-top:8px;",
      "attrs": {
        "type": "warning",
        "message": message
      }
    });
  }
  renderExampleForm() {
    const h = this.$createElement;
    const style = 'margin:0;';
    return h("a-form-model", {
      "style": "padding:20px 0;display:block;"
    }, [h("a-form-model-item", {
      "style": style
    }, [h("a-checkbox", {
      "model": {
        value: this.schema['ds:useExample'],
        callback: $$v => {
          this.$set(this.schema, 'ds:useExample', $$v);
        }
      }
    }, ["\u542F\u7528\u793A\u4F8B\u503C\uFF08Mock\uFF09"])]), this.useExample && h("a-form-model-item", {
      "attrs": {
        "label": "请输入示例值"
      },
      "style": style
    }, [h(AnyInput, {
      "ref": "anyInput",
      "style": "height:200px",
      "attrs": {
        "description": "编一个假数据，以便在设计页面时看效果"
      },
      "model": {
        value: this.schema.example,
        callback: $$v => {
          this.$set(this.schema, "example", $$v);
        }
      }
    }), h("a-button", {
      "style": "position: absolute;top: -32px;right: 0px;padding:0;",
      "attrs": {
        "type": "link"
      },
      "on": {
        "click": this.useValueAsExample
      }
    }, ["\u4ECE\u5F53\u524D\u771F\u5B9E\u503C\u590D\u5236"])]), this.renderDiffTip()]);
  }
  render() {
    const h = arguments[0];
    return h("a-modal", {
      "attrs": {
        "visible": true,
        "width": 800
      },
      "on": {
        "cancel": this.cancel
      },
      "scopedSlots": {
        title: () => h("a-space", [h("span", ["\u7F16\u8F91\u53D8\u91CF\u7C7B\u578B"])])
      }
    }, [this.originSchema && h("a-form", {
      "attrs": {
        "layout": "inline"
      }
    }, [h("a-form-item", {
      "attrs": {
        "label": "变量路径"
      }
    }, [h("a-input", {
      "attrs": {
        "value": this.originSchema.id,
        "disabled": true
      }
    }, [h("span", {
      "slot": "addonBefore"
    }, ["data.", this.sourceId, "."])])])]), this.renderExampleForm(), this.renderSchemaInfo(), this.renderFooter()]);
  }
  renderFooter() {
    var _schemaProcess$show;
    const h = this.$createElement;
    const {
      schemaProcess,
      designer,
      instance
    } = this.options;
    const isShowUpdateByValue = (_schemaProcess$show = schemaProcess === null || schemaProcess === void 0 ? void 0 : schemaProcess.show({
      designer,
      instance
    })) !== null && _schemaProcess$show !== void 0 ? _schemaProcess$show : false;
    return h("a-space", {
      "slot": "footer"
    }, [this.showResetEntity && h("a-popconfirm", {
      "attrs": {
        "placement": "top",
        "ok-text": "确认",
        "cancel-text": "取消"
      },
      "on": {
        "confirm": this.reset
      }
    }, [h("p", {
      "slot": "title"
    }, ["\u786E\u8BA4\u8FD8\u539F\u53D8\u91CF\u7C7B\u578B\u5417\uFF1F"]), h("a-button", {
      "attrs": {
        "disabled": !this.showResetEntity
      }
    }, ["\u8FD8\u539F\u53D8\u91CF\u7C7B\u578B\uFF08\u4E0E\u5B9E\u4F53\u4FDD\u6301\u4E00\u81F4\uFF09"])]), isShowUpdateByValue && !this.useExample && h("a-button", {
      "on": {
        "click": this.updateByValue
      }
    }, ["\u6839\u636E\u5F53\u524D\u503C\u66F4\u65B0\u7C7B\u578B"]), h("a-button", {
      "attrs": {
        "type": "primary",
        "disabled": this.useExample && this.schema.example === undefined
      },
      "on": {
        "click": this.update
      }
    }, ["\u4FDD\u5B58\u66F4\u6539"])]);
  }
};
__decorate([Prop()], DsVarModal.prototype, "options", void 0);
DsVarModal = __decorate([Component({
  name: 'DsVarModal'
})], DsVarModal);
export default DsVarModal;
//# sourceMappingURL=DsVarModal.js.map
